import React, { useState } from 'react';

interface AccordianProps{
    title: string;
    content: string[];
    link: string[] | undefined;
}

const Accordion = (props: AccordianProps): JSX.Element => {
    const { title, content, link } = props;
    const [isActive, setIsActive] = useState(false);

    return (
        <div className='accordion-item' style={{ paddingTop: 10, paddingBottom: 10, borderBottom: '1px solid #8CB5C9' }}>
            <div className='accordion-title' onClick={() => setIsActive(!isActive)} aria-hidden style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div><p style={{ color: '#8CB5C9', fontSize: '1.4rem', margin: 0 }}>{title}</p></div>
                <div>{isActive ? (<img src='/assets/icons/ArrowUp.svg' alt='open' />) : (<img src='/assets/icons/ArrowUp.svg' alt='close' style={{ transform: 'rotate(180deg)' }} />)}</div>
            </div>
            {isActive && (
                <div style={{ paddingTop: 10 }}>
                    {
                        title === 'Get in Touch'
                            ? (
                                <>
                                    <div style={{ display: 'flex', gap: 20 }}>
                                        <img src='assets/icons/Phone.png' alt='' style={{ height: 15, width: 15 }} />
                                        <p style={{ color: 'white', fontSize: '1.1rem', fontFamily: 'AcuminRPro' }}>75, Jalan Austin Heights 3, Taman Mount Austin, 81100 Johor Bahru, Johor, Malaysia.</p>
                                    </div>
                                    <div style={{ display: 'flex', gap: 20 }}>
                                        <img src='assets/icons/location.png' alt='' style={{ height: 15, width: 15, marginTop: -3 }} />
                                        <p style={{ color: 'white', fontSize: '1.1rem', fontFamily: 'AcuminRPro' }}>+60 16-773 0338</p>
                                    </div>
                                    <div style={{ display: 'flex', gap: 20 }}>
                                        <img src='assets/icons/mail.png' alt='' style={{ height: 15, width: 15, marginTop: -3 }} />
                                        <p style={{ color: 'white', fontSize: '1.1rem', fontFamily: 'AcuminRPro' }}>online@tiansi.my</p>
                                    </div>
                                </>
                            )
                            : (
                                <>
                                    { content.map((item, index) => {
                                        const nameOnly = item.replace(/(.*)-/, '').toLocaleLowerCase();

                                        if (link) {
                                            return (
                                                <a href={link[index]} style={{ textDecoration: 'none' }}>
                                                    <p style={{ color: 'white', fontSize: '1.1rem', fontFamily: 'AcuminRPro', textTransform: 'capitalize' }}>
                                                        {item}
                                                    </p>
                                                </a>
                                            );
                                        }
                                        return (
                                            <a href={`${process.env.REACT_APP_BASE_URL}/categories/${item}`} style={{ textDecoration: 'none' }}>
                                                <p style={{ color: 'white', fontSize: '1.1rem', fontFamily: 'AcuminRPro', textTransform: 'capitalize' }}>
                                                    {nameOnly}
                                                </p>
                                            </a>
                                        );
                                    })}
                                </>
                            )

                    }
                </div>
            )}
        </div>
    );
};

export default Accordion;
